<script lang="ts">
  import { IconType } from '$shared/constants/IconType';

  interface Props {
    type?: IconType | string;
    value?: string;
    disabled?: boolean;
    size?: string;
    fontSize?: string;
    name?: any;
    onclick?: (e: MouseEvent) => void;
    children?: import('svelte').Snippet;
  }

  let {
    type = '',
    value = '',
    disabled = false,
    size = '16px',
    fontSize = '16px',
    name = value,
    onclick,
    children
  }: Props = $props();

  const sizeClassname = $derived(size ? `icon-size-${size}` : '');
  const fontSizeClassname = $derived(fontSize ? `icon-font-size-${fontSize}` : '');
  const classnames = $derived(`comp-icon ${value} ${sizeClassname} ${fontSizeClassname}`);
</script>

{#if type === IconType.Button}
  <button
    data-cy={name}
    type="button"
    class={classnames}
    {disabled}
    onclick={(e) => { e.preventDefault(); e.stopPropagation(); onclick?.(e); }}
  >
    {@render children?.()}
  </button>
{:else}
  <span data-cy={name} class={classnames}>{''}</span>
{/if}

<style src="./Icon.css">
</style>
